import React from 'react'

const LiveChatCall = () => {
  return (
    <div>LiveChatCall</div>
  )
}

export default LiveChatCall